import Vue from 'vue'
import Router from 'vue-router'

import TabAbout from '@/components/TabAbout.vue'
import TabData from '@/components/TabData.vue'
import TabDetails from '@/components/TabDetails.vue'
import TabFilter from '@/components/TabFilter.vue'
import TabFilterCountry from '@/components/TabFilterCountry.vue'
import TabFilterGeneral from '@/components/TabFilterGeneral.vue'
import TabFilterGenre from '@/components/TabFilterGenre.vue'
import TabFilterLanguage from '@/components/TabFilterLanguage.vue'
import TabSearch from '@/components/TabSearch.vue'
import TabShow from '@/components/TabShow.vue'
import TabSort from '@/components/TabSort.vue'

Vue.use(Router)

routes = [
    {
        path: '/details'
        name: 'details'
        component: TabDetails
    }
    {
        path: '/details/:id'
        name: 'details'
        component: TabDetails
        props: true
    }
    {
        path: '/show'
        name: 'show'
        component: TabShow
    }
    {
        path: '/search'
        name: 'search'
        component: TabSearch
    }
    {
        path: '/filter'
        name: 'filter'
        component: TabFilter
        children: [
            {
                path: ''
                name: 'filter_general'
                component: TabFilterGeneral
            }
            {
                path: 'genre'
                name: 'filter_genre'
                component: TabFilterGenre
            }
            {
                path: 'language'
                name: 'filter_language'
                component: TabFilterLanguage
            }
            {
                path: 'country'
                name: 'filter_country'
                component: TabFilterCountry
            }
        ]
    }
    {
        path: '/sort'
        name: 'sort'
        component: TabSort
    }
    {
        path: '/data'
        name: 'data'
        component: TabData
    }
    {
        path: '/about'
        name: 'about'
        component: TabAbout
    }
]

router = new Router
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes: routes

router.beforeEach (to, from, next) ->
    console.log to.path, from.path

    # if not Auth.isAuthenticated() and to.path != '/logincb'
    #     Auth.check().then () =>
    #         next(to.path)
    #     return

    next()

export default router
